export const fontSizes = {
  h1: {
    base: "2.2rem",
    sm: "3rem",
    md: "3.45rem",
    lg: "3.975rem"
  },
  h2: {
    base: "1.8rem",
    sm: "2.4rem",
    md: "2.55rem",
    lg: "2.7rem"
  },
  h3: {
    base: "1.45rem",
    sm: "1.8rem",
    md: "1.875rem",
    lg: "1.875rem"
  },
  h4: {
    base: "1.2rem",
    sm: "1.35rem",
    md: "1.35rem",
    lg: "1.35rem"
  },
  h5: {
    base: "1.05rem",
    sm: "1.24rem",
    md: "1.275rem",
    lg: "1.275rem"
  },
  h6: {
    base: "0.8rem",
    sm: "0.9rem",
    md: "0.9rem",
    lg: "0.9rem"
  },
  body1: {
    base: "0.8125rem",
    sm: "0.9rem",
    md: "0.9375rem",
    lg: "0.9375rem"
  },
  body2: {
    base: "0.75rem",
    sm: "0.85rem",
    md: "0.875rem",
    lg: "0.875rem"
  },
  subtitle1: {
    base: "0.875rem",
    sm: "1rem",
    md: "1rem",
    lg: "1rem"
  },
  subtitle2: {
    base: "0.8125rem",
    sm: "0.9rem",
    md: "0.9375rem",
    lg: "0.9375rem"
  },
  caption: {
    base: "0.7rem",
    sm: "0.75rem",
    md: "0.75rem",
    lg: "0.75rem"
  }
};
const buildResponsiveFont = (theme, scale, overrides = {}) => {
  const style = {
    fontSize: scale.base,
    ...overrides
  };
  if (scale.sm) {
    style[theme.breakpoints.up("sm")] = {
      fontSize: scale.sm
    };
  }
  if (scale.md) {
    style[theme.breakpoints.up("md")] = {
      ...(style[theme.breakpoints.up("sm")] || {}),
      fontSize: scale.md
    };
  }
  if (scale.lg) {
    style[theme.breakpoints.up("lg")] = {
      ...(style[theme.breakpoints.up("md")] || {}),
      fontSize: scale.lg
    };
  }
  if (scale.xl) {
    style[theme.breakpoints.up("xl")] = {
      ...(style[theme.breakpoints.up("lg")] || {}),
      fontSize: scale.xl
    };
  }
  return style;
};
export const createTypography = theme => ({
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  h1: buildResponsiveFont(theme, fontSizes.h1, {
    fontWeight: 600,
    lineHeight: 1.15
  }),
  h2: buildResponsiveFont(theme, fontSizes.h2, {
    fontWeight: 600,
    lineHeight: 1.35
  }),
  h3: buildResponsiveFont(theme, fontSizes.h3, {
    fontWeight: 600,
    lineHeight: 1.4
  }),
  h4: buildResponsiveFont(theme, fontSizes.h4, {
    fontWeight: 600,
    lineHeight: 1.5
  }),
  h5: buildResponsiveFont(theme, fontSizes.h5, {
    fontWeight: 600,
    lineHeight: 1.55
  }),
  h6: buildResponsiveFont(theme, fontSizes.h6, {
    fontWeight: 600,
    lineHeight: 1.5,
    textTransform: "uppercase"
  }),
  subtitle1: buildResponsiveFont(theme, fontSizes.subtitle1, {
    fontWeight: 400,
    lineHeight: 1.5
  }),
  subtitle2: buildResponsiveFont(theme, fontSizes.subtitle2, {
    fontWeight: 500,
    lineHeight: 1.4
  }),
  body1: buildResponsiveFont(theme, fontSizes.body1, {
    fontWeight: 400,
    lineHeight: 1.6
  }),
  body2: buildResponsiveFont(theme, fontSizes.body2, {
    fontWeight: 400,
    lineHeight: 1.55
  }),
  caption: buildResponsiveFont(theme, fontSizes.caption, {
    fontWeight: 400,
    lineHeight: 1.4
  })
});
const buildVarMap = variant => {
  const vars = {};
  Object.keys(fontSizes).forEach(key => {
    const value = fontSizes[key][variant];
    if (value) {
      vars[`--pc-font-${key}`] = value;
    }
  });
  return vars;
};
export const createFontSizeCssVariables = theme => {
  const baseVars = buildVarMap("base");
  const smVars = buildVarMap("sm");
  const mdVars = buildVarMap("md");
  const lgVars = buildVarMap("lg");
  const xlVars = buildVarMap("xl");
  const overrides = {
    ":root": baseVars
  };
  if (Object.keys(smVars).length) {
    overrides[theme.breakpoints.up("sm")] = {
      ":root": smVars
    };
  }
  if (Object.keys(mdVars).length) {
    overrides[theme.breakpoints.up("md")] = {
      ":root": mdVars
    };
  }
  if (Object.keys(lgVars).length) {
    overrides[theme.breakpoints.up("lg")] = {
      ":root": lgVars
    };
  }
  if (Object.keys(xlVars).length) {
    overrides[theme.breakpoints.up("xl")] = {
      ":root": xlVars
    };
  }
  return overrides;
};